import React from 'react';
import update from 'react-addons-update';
import Submenu from './Submenu';

// import MapLink from '../MapLink';

class LocationMenu extends Submenu {

  // static propTypes = {
  //   locations: React.PropTypes.object.isRequired
  // }

  constructor(props) {
    super(props);
    this.locations = props.locations;
    this.analytics = this.props.analytics;
    this.state = {
      original_tree: this.locations,
      child_keys: this.getRegions(this.locations),
      region_tree: this.locations,
      parent_tree: false,
      parent_key: false,
    };
  }

  getRegions(tree) {
    if (tree) {
      let regions = Object.keys(tree);
      return regions;
    }
  }

  // return the first node that has `slug` as a key
  getParent(node, slug) {
    if (node.children || node.hasOwnProperty('id')) {
      let theKeys = node.hasOwnProperty('id') ? Object.keys(node) : Object.keys(node.children);
      if (theKeys.indexOf(slug) > -1) {
        return node;
      } else {
        let result;
        for(let i=0; result == null && i < theKeys.length; i++)
            result = this.getParent(node[theKeys[i]], slug);
        return result;
      }
    }
    return null;
  };

  getRegion(node, slug) {
    if (!node) return null;
    if (node.slug || node.hasOwnProperty('id')) {
      let theKeys = node.hasOwnProperty('id') ? Object.keys(node) : Object.keys(node.children);
      if (node.slug === slug) {
        return node;
      } else {
        let result;
        for(let i=0; result == null && i < theKeys.length; i++)
            result = this.getRegion(node[theKeys[i]], slug);
        return result;
      }
    }
    return null;
  }

  setRegion(region) {
    if (region.hasOwnProperty('id')) { // this is the root of the tree
      this.setState(update(this.state,
        {$set: {
          original_tree: region,
          child_keys: this.getRegions(region),
          region_tree: region,
          parent_tree: false,
          parent_key: false,
        } }
      ));
    } else if (!region.slug) { // move up the tree
      let tree = this.getRegion(this.state.original_tree, this.state.parent_key);
      let parentTree = this.getParent(this.state.original_tree, tree.slug);
      this.setState(update(this.state,
        {$set: {
          child_keys: this.getRegions(tree.children),
          region_tree: tree.children,
          parent_tree: parentTree,
          parent_key: parentTree.slug || false,
          region_key: tree.slug,
        } }
      ));
    } else { // move down the tree
      let tree = region.children;
      this.setState(update(this.state,
        {$set: {
          child_keys: this.getRegions(tree),
          region_tree: tree,
          parent_tree: this.state.region_tree,
          parent_key: this.state.region_key,
          region_key: region.slug,
        } }
      ));
    }
  }

  hasChildren(region) {
    return (region && region.children) ? true : false;
  }

  gotoMap(slug, lat, lon) {
    if (window) {
      window.location.assign(`/map/${slug}`);
    }
  }



  render() {
    let navClasses = super.getMenuClasses('locationMenu');
    return (
      <ul id="locationMenu" className={navClasses}>
        <li className="header">Locations</li>
        {(() => {
          if (this.state.parent_tree)
            return (
              <li className="default parent"
                onClick={this.setRegion.bind(this, this.state.parent_tree)}>
                <a href="#">
                  <i className="fa fa-angle-left"></i>&nbsp;&nbsp;&nbsp;
                  {this.state.parent_tree[this.state.region_key].name}
                </a>
              </li>
            );
        })()}

        {
          this.state.child_keys.map(region => {
            let node = this.state.region_tree[region];
            if (this.hasChildren(node)) {
              return (
                <li className="default"
                  onClick={this.setRegion.bind(this, node)}>
                  <a href="#">
                    {node.name} <i className="fa fa-angle-right"></i>
                  </a>
                </li>
              );
            } else if (node && node.location) {
              let [lat, lon] = node.location.coordinates;
              return (
                <li className="default"
                  onClick={this.gotoMap.bind(this, node.slug, lat, lon)}>
                  <a href="#">
                    {node.name}
                  </a>
                </li>
              );
            }
          })
        }
      </ul>
    );
  }

}

export default LocationMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/MobileLocationMenu.js